import type { EstructuraDocumentalEmpresaAgentesModel } from "@api/api";

/**
 * Combina la plantilla devuelta para una forma jurídica con los adjuntos ya
 * presentes en la estructura anterior cuando el tipo de documento coincide.
 */
export function mergeEstructuraDocumentalEmpresaAgentesPreservandoAdjuntosComunes(
  nuevaPlantilla: EstructuraDocumentalEmpresaAgentesModel[],
  estructuraAnterior: EstructuraDocumentalEmpresaAgentesModel[],
): EstructuraDocumentalEmpresaAgentesModel[] {
  const adjuntoPorTipo = new Map<
    string,
    Pick<EstructuraDocumentalEmpresaAgentesModel, "IdDocumentoAdjunto" | "NombreAdjunto" | "RutaAdjunto">
  >();
  for (const fila of estructuraAnterior) {
    const tipo = String(fila.TipoDocumento);
    const id = fila.IdDocumentoAdjunto;
    if (id != null && String(id).trim() !== "") {
      adjuntoPorTipo.set(tipo, {
        IdDocumentoAdjunto: fila.IdDocumentoAdjunto,
        NombreAdjunto: fila.NombreAdjunto,
        RutaAdjunto: fila.RutaAdjunto,
      });
    }
  }
  return nuevaPlantilla.map((fila) => {
    const preserved = adjuntoPorTipo.get(String(fila.TipoDocumento));
    if (!preserved) {
      return { ...fila };
    }
    return {
      ...fila,
      ...preserved,
    };
  });
}

/** Encola tareas async para que las actualizaciones de estructura no se pisen. */
export function createAsyncSerialTaskRunner(): (task: () => Promise<void>) => Promise<void> {
  let tail: Promise<void> = Promise.resolve();
  return (task: () => Promise<void>): Promise<void> => {
    const p = tail.then(() => task());
    tail = p.catch(() => {});
    return p;
  };
}
